import { Controller } from '@hotwired/stimulus';
import "bootstrap";  // Ensure Bootstrap is imported

export default class extends Controller {

  connect() {
    $(this.element).toast('show');
  }
}
